import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import ItemCarousel from '../item/ItemCarousel';
import PlaceHolder from '../common/PlaceHolder';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
const LearningBoardWidget = ({ configId, limitToPageWidth = false, editData, maxItemCount, }) => {
    const { currentLearningBoard: board, currentPortal } = useStore();
    // don't render the widget on the server because account is not loaded yet
    if (typeof window === 'undefined') {
        return _jsx("div", { children: "..." });
    }
    if (editData && !board) {
        return (_jsx(PlaceHolder, { placeHolderName: "Learning Board" }));
    }
    if (!board) {
        // Check if there's a custom message configured in learningBoardConfig
        const { learningBoardConfig } = currentPortal;
        const customMessage = learningBoardConfig?.noDataMessage;
        if (customMessage && customMessage.slate && customMessage.slate.length > 0) {
            return (_jsx(Box, { sx: {
                    ...(limitToPageWidth && {
                        maxWidth: 1200,
                        marginX: 'auto',
                        width: '100%',
                    }),
                }, children: _jsx(WysiwygViewer, { id: "learning-board-no-data-message", value: customMessage.slate }) }));
        }
        // Fallback to default message
        return (_jsx(Typography, { className: "systemPagesMessage", sx: {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 33,
            }, children: "A Learning Board has not yet been created for this account.  Check back later." }));
    }
    if (board?.syncState === 'not_found') {
        return (_jsx(Typography, { className: "systemPagesMessage", children: "No learning board found." }));
    }
    return (_jsxs(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: [_jsx(Typography, { variant: "h2", className: "systemPageTitle", sx: { m: 0.5, fontSize: '24px' }, children: board.name }), board.sections.map((section) => (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: { m: 0.5 }, children: _jsx(Typography, { variant: "h5", sx: {
                                fontWeight: 'bold',
                                fontSize: '21px',
                                pt: '5px',
                                pb: '10px',
                            }, children: section.name }) }), section.type === 'category' && (_jsx(ItemCarousel, { categoryId: section.category?.id, maxItemCount: maxItemCount, showTitle: false, backgroundColor: "white", showPrice: false, editData: null, 
                        // title={section.name}
                        configId: configId, limitToPageWidth: true })), section.type === 'custom' && (_jsx(ItemCarousel, { items: section.items, maxItemCount: maxItemCount, showTitle: false, backgroundColor: "white", showPrice: false, editData: null, 
                        // title={section.name}
                        configId: configId, limitToPageWidth: true }))] }, section.id)))] }));
};
LearningBoardWidget.defaultProps = {
    limitToPageWidth: false,
    editData: undefined,
    maxItemCount: 25,
};
LearningBoardWidget.meta = {
    group: 'display',
    name: 'Learning Board',
    description: 'Displays the current customer\'s Learning Board.',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        {
            key: 'maxItemCount',
            name: 'Max Item Count',
            type: 'number',
            description: 'The maximum number of items to display in each section (default is 25).',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'LearningBoardWidget',
        props: {
            limitToPageWidth: true,
            maxItemCount: 25,
        },
    },
};
export default observer(LearningBoardWidget);
//# sourceMappingURL=LearningBoardWidget.js.map